// hooks/useTabNavigation.js - Simplified version to prevent re-render issues
import { useMemo, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useTabNavigation = (tabs, defaultTab = 'overview') => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get current active tab from URL
  const activeTab = useMemo(() => {
    const tabFromUrl = searchParams.get('tab');
    const validTabIds = tabs.map(tab => tab.id);
    return validTabIds.includes(tabFromUrl) ? tabFromUrl : defaultTab;
  }, [searchParams, tabs, defaultTab]);

  // Handle tab change
  const changeTab = useCallback((tabId) => {
    const isValidTab = tabs.some(tab => tab.id === tabId);
    if (isValidTab && tabId !== activeTab) {
      setSearchParams({ tab: tabId }, { replace: true });
    }
  }, [tabs, setSearchParams, activeTab]);

  return { activeTab, changeTab };
};
